import {IDeviceTypeDetectionService} from './device-type-detection.service.interface';
import {LauncherServiceBase} from '../launcher-service-base';
import {ILauncherServiceFactory} from '../launcher-service-factory.interface';
import {action, observable} from 'mobx';

const MIN_WIDTH_FOR_PC = 1280;
export class DeviceTypeDetectionService extends LauncherServiceBase implements IDeviceTypeDetectionService {

    constructor(services: ILauncherServiceFactory){
        super(services);
        this._updateIsMobile();
        this.services.window.subscribeTo.resize(() => this._updateIsMobile())
    }

    @observable.ref isMobile: boolean;

    @action.bound
    private _updateIsMobile(): void {
        this.isMobile = this.services.window.innerWidth < MIN_WIDTH_FOR_PC;
    }
}